import React from 'react';
import { Video } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-800" data-id="element-34">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8" data-id="element-35">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8" data-id="element-36">
          <div className="space-y-8 xl:col-span-1" data-id="element-37">
            <div className="flex items-center" data-id="element-38">
              <Video className="h-8 w-8 text-indigo-400" data-id="element-39" />
              <span className="ml-2 text-xl font-bold text-white" data-id="element-40">
                VideoScribe
              </span>
            </div>
            <p className="text-gray-300 text-base" data-id="element-41">
              Transform your YouTube videos into engaging blog posts and dub
              them into multiple languages with perfect subtitles.
            </p>
            <div className="flex space-x-6" data-id="element-42">
              <a href="#" className="text-gray-400 hover:text-gray-300" data-id="element-43">
                <span className="sr-only" data-id="element-44">Facebook</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-45">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" data-id="element-46" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-gray-300" data-id="element-47">
                <span className="sr-only" data-id="element-48">Twitter</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-49">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-50" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-gray-300" data-id="element-51">
                <span className="sr-only" data-id="element-52">YouTube</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-53">
                  <path fillRule="evenodd" d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z" clipRule="evenodd" data-id="element-54" />
                </svg>
              </a>
            </div>
          </div>
          <div className="mt-12 grid grid-cols-2 gap-8 xl:mt-0 xl:col-span-2" data-id="element-55">
            <div className="md:grid md:grid-cols-2 md:gap-8" data-id="element-56">
              <div data-id="element-57">
                <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase" data-id="element-58">
                  Solutions
                </h3>
                <ul className="mt-4 space-y-4" data-id="element-59">
                  <li data-id="element-60">
                    <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-61">
                      Video Transcription
                    </a>
                  </li>
                  <li data-id="element-62">
                    <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-63">
                      Blog Conversion
                    </a>
                  </li>
                  <li data-id="element-64">
                    <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-65">
                      Video Dubbing
                    </a>
                  </li>
                  <li data-id="element-66">
                    <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-67">
                      Subtitle Generation
                    </a>
                  </li>
                </ul>
              </div>
              <div className="mt-12 md:mt-0" data-id="element-68">
                <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase" data-id="element-69">
                  Support
                </h3>
                <ul className="mt-4 space-y-4" data-id="element-70">
                  <li data-id="element-71">
                    <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-72">
                      Pricing
                    </a>
                  </li>
                  <li data-id="element-73">
                    <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-74">
                      Documentation
                    </a>
                  </li>
                  <li data-id="element-75">
                    <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-76">
                      Guides
                    </a>
                  </li>
                  <li data-id="element-77">
                    <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-78">
                      API Status
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8" data-id="element-79">
              <div data-id="element-80">
                <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase" data-id="element-81">
                  Company
                </h3>
                <ul className="mt-4 space-y-4" data-id="element-82">
                  <li data-id="element-83">
                    <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-84">
                      About
                    </a>
                  </li>
                  <li data-id="element-85">
                    <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-86">
                      Blog
                    </a>
                  </li>
                  <li data-id="element-87">
                    <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-88">
                      Jobs
                    </a>
                  </li>
                  <li data-id="element-89">
                    <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-90">
                      Press
                    </a>
                  </li>
                </ul>
              </div>
              <div className="mt-12 md:mt-0" data-id="element-91">
                <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase" data-id="element-92">
                  Legal
                </h3>
                <ul className="mt-4 space-y-4" data-id="element-93">
                  <li data-id="element-94">
                    <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-95">
                      Privacy
                    </a>
                  </li>
                  <li data-id="element-96">
                    <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-97">
                      Terms
                    </a>
                  </li>
                  <li data-id="element-98">
                    <a href="#" className="text-base text-gray-300 hover:text-white" data-id="element-99">
                      Cookie Policy
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 border-t border-gray-700 pt-8" data-id="element-100">
          <p className="text-base text-gray-400 xl:text-center" data-id="element-101">
            &copy; 2023 VideoScribe. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}